// Convert raw hours to billable days using the user's calibration.
// dayHours is the configured "1 productive day = N hours" value; with the
// default of 8, six tracked hours read as 0.75d.
export function hoursToDays(hours: number, dayHours: number): number {
  if (dayHours <= 0) return 0;
  return hours / dayHours;
}

// Format a day count as "1.8d". Defaults to one decimal so 0.4d still surfaces;
// callers that want whole-day display can pass 0.
export function formatDays(days: number, fractionDigits = 1): string {
  return `${days.toFixed(fractionDigits)}d`;
}
